import { HistoricoEmenda } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class HistoricoEmendaItem extends BaseResourceModel {
  constructor(
    public id?: number,
    public historico?: HistoricoEmenda,
    public campo?: string,
    public antes?: string,
    public depois?: string,
    public campo_entidade?: boolean,
  ) {
    super();
  }

  static converteJson(json: any): HistoricoEmendaItem {
    return Object.assign(new HistoricoEmendaItem(), json);
  }
}
